import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import PageHeader, { btnPrimary, cardClass } from '../components/PageHeader';

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiFetch(`/admin/vendors?include_inactive=${showInactive}`)
      .then((r) => setVendors(r.data || []))
      .finally(() => setLoading(false));
  }, [showInactive]);

  return (
    <div>
      <PageHeader
        title="Teams & partners"
        subtitle="In-house North County crew and vetted partner cleaners nationwide"
        action={
          <Link to="/vendors/new" className={btnPrimary}>
            New team / partner
          </Link>
        }
      />

      <label className="flex items-center gap-2 text-sm text-slate-600 mb-4">
        <input
          type="checkbox"
          checked={showInactive}
          onChange={(e) => setShowInactive(e.target.checked)}
        />
        Show inactive
      </label>

      <div className={cardClass}>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-left">
            <tr>
              <th className="px-5 py-3">Display name</th>
              <th className="px-5 py-3">Email</th>
              <th className="px-5 py-3">Phone</th>
              <th className="px-5 py-3">Portal</th>
              <th className="px-5 py-3">Onboarding</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3" />
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="px-5 py-8 text-center text-slate-500">
                  Loading…
                </td>
              </tr>
            ) : (
              vendors.map((v) => (
                <tr key={v.id} className="border-t border-slate-100">
                  <td className="px-5 py-3 font-medium">{v.display_name}</td>
                  <td className="px-5 py-3">{v.email}</td>
                  <td className="px-5 py-3">{v.phone || '—'}</td>
                  <td className="px-5 py-3">
                    {v.portal_status === 'active' ? (
                      <span className="text-green-700">Signed up</span>
                    ) : (
                      <span className="text-amber-700">Invite pending</span>
                    )}
                  </td>
                  <td className="px-5 py-3 capitalize">
                    {v.onboarding_status === 'pending_approval' ? (
                      <Link
                        to={`/vendor-applications/${v.id}`}
                        className="text-amber-700 font-medium hover:underline"
                      >
                        Pending review
                      </Link>
                    ) : (
                      (v.onboarding_status || 'approved').replace(/_/g, ' ')
                    )}
                  </td>
                  <td className="px-5 py-3">
                    {v.is_active && v.user_active !== false ? 'Active' : 'Inactive'}
                  </td>
                  <td className="px-5 py-3 text-right">
                    <Link to={`/vendors/${v.id}/edit`} className="text-teal-700 hover:underline">
                      Edit
                    </Link>
                  </td>
                </tr>
              ))
            )}
            {!loading && vendors.length === 0 && (
              <tr>
                <td colSpan={7} className="px-5 py-8 text-center text-slate-500">
                  No teams or partners yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Vendors;
